/** Admin-web Supabase client singleton (anon key; RLS-enforced). */
import { createGymClient, type GymSupabaseClient } from '@gym/api-client';

export const supabase: GymSupabaseClient = createGymClient({
  url: import.meta.env.VITE_SUPABASE_URL ?? '',
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
});
